import React from 'react'

export const Breadcrumb = React.memo(({pbData})=> {
    const navItemsList = pbData?.homewardPathSegments?.length
        ? pbData?.homewardPathSegments
        : []

    return (
        <nav aria-label="Breadcrumb">
            <ol className="breadcrumbs">
            {
                navItemsList.map((breadcrumbs, index) =>
                    <li key={index}>
                        {
                            breadcrumbs.url
                            ? <a href={breadcrumbs.url}><span dangerouslySetInnerHTML={{ __html: breadcrumbs.displayName }}/></a>
                            : <span dangerouslySetInnerHTML={{ __html: breadcrumbs.displayName }}/>
                        }
                    </li>
                )
            }
         </ol>
        </nav>
    )
})